import { render, staticRenderFns } from "./LeaveDefaultsSettingsCard.vue?vue&type=template&id=015b671f&scoped=true"
import script from "./LeaveDefaultsSettingsCard.vue?vue&type=script&lang=js"
export * from "./LeaveDefaultsSettingsCard.vue?vue&type=script&lang=js"
import style0 from "./LeaveDefaultsSettingsCard.vue?vue&type=style&index=0&id=015b671f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b671f",
  null
  
)

export default component.exports